import React, { Component } from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import hocConnect from './hocConnect'

@hocConnect
export default class PaymentInformationsTerminology extends Component {
    static propTypes = {
        block: PropTypes.string.isRequired,
        customData: PropTypes.object,
        id: PropTypes.string.isRequired,
        module: PropTypes.string.isRequired,
        isTerminologyOpen: PropTypes.bool,
        paymentIndexToggleTerminology: PropTypes.func.isRequired,
        translates: PropTypes.shape({
            terminologyToggleText: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            riskIndicatorInfoTextYear: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
            riskIndicatorInfoTextQuarter: PropTypes.oneOfType([PropTypes.string, PropTypes.element]).isRequired,
        }).isRequired,
    }

    toggleTerminologyTexts = () => {
        const { module, id, block, customData, isTerminologyOpen, paymentIndexToggleTerminology } = this.props

        paymentIndexToggleTerminology(module, id, block, { ...customData, isTerminologyOpen: !isTerminologyOpen })
    }

    render() {
        const {
            isTerminologyOpen,
            translates: { terminologyToggleText, riskIndicatorInfoTextQuarter },
        } = this.props

        return (
            <div className={'terminology-wrap'}>
                <div onClick={this.toggleTerminologyTexts} className={'terminology-toggle'}>
                    <div className={cx('terminology-toggle-icon', isTerminologyOpen ? 'expand' : 'collapse')} />
                    <div className={'terminology-toggle-button'}>{terminologyToggleText}</div>
                </div>
                {isTerminologyOpen && <div className={'terminology-texts'}>{riskIndicatorInfoTextQuarter}</div>}
            </div>
        )
    }
}
